import { useState, useEffect, useReducer } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

// import TableFirmSettings from "../../common/table-firm-settings";
import { api_without_cancellation } from "../../../../api/api";
import { mediaRoute } from "../../../../Utils/helper";
import { useDocumentModal } from "../../../common/CustomModal/CustomModalContext";

const CourtForms = () => {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const [courtForms, setCourtForms] = useState([]);
  const { showDocumentModal } = useDocumentModal();
  const [statesCount, setStatesCount] = useState(0);
  const [countyCount, setCountyCount] = useState(0);

  const initialState = {
    show: false,
    status: "",
  };

  const handleDocPreview = (doc) => {
    showDocumentModal("document", mediaRoute(doc.upload), doc);
  };

  const fetchCountData = async () => {
    try {
      const response = await api_without_cancellation.get(
        origin + "/api/firmsetting-page/objections-filter-data/"
      );
      if (response.status === 200) {
        setStatesCount(response?.data?.states?.length);
        setCountyCount(response?.data?.counties?.length);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCourtForms = async () => {
    try {
      const response = await api_without_cancellation.get(
        origin + "/api/court-form/get-courtforms/"
      );
      if (response.status === 200) {
        setCourtForms(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCountData();
    fetchCourtForms();
  }, []);

  function reducer(state, action) {
    switch (action.type) {
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };

      default:
        return state;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  const handleFileUpload = async (event, court_form_id) => {
    const file = event.target.files[0];

    const formData = new FormData();
    formData.append("file", file);
    formData.append("court_form_id", court_form_id);

    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/court-form/upload-courtform-pdf/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        fetchCourtForms();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {/* <TableFirmSettings> */}
      <div className="d-flex flex-column justify-content-between">
        <div className="table-responsive table--no-card rounded-0 border-0">
          <table className="table table-borderless table-striped table-earning has-height-25 generate-doc-table">
            <thead>
              <tr>
                <th />
                <th>Name</th>
                {/* <th>Form</th> */}
                <th>Jurisdiction</th>
                <th>States</th>
                <th>Counties</th>
                <th />
                <th />
              </tr>
            </thead>
            <tbody id="table-body-cat" className="generate-doc-body">
              {courtForms &&
                courtForms?.map((item, idx) => {
                  const courtFormStates = item?.for_states?.length || 0;
                  const courtFormCounties = item?.for_counties?.length || 0;
                  return (
                    <tr key={item.id} style={{ height: "35px" }}>
                      <td style={{ width: "35px" }}>{idx + 1}</td>
                      <td className="color-white-space-word-wrap" style={{ textAlign: "left" }}>
                        <span
                          style={{ position: "relative", top: "2px" }}
                          className="ic ic-19 ic-court-form"
                        />{" "}
                        <span>
                          {" "}
                          {item?.court_form_code || "-"}: {item?.court_form_name || ""}
                        </span>
                      </td>
                      <td
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                        }}
                      >
                        {item?.for_jurisdiction_types?.map((state) => state.name).join(", ")}
                      </td>
                      <td
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                        }}
                      >
                        {/* All States */}
                        {courtFormStates === statesCount
                          ? "All States"
                          : item?.for_states?.map((state) => state.name).join(", ")}
                      </td>
                      <td
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                        }}
                      >
                        {/* All Counties */}
                        {courtFormCounties === countyCount
                          ? "All Counties"
                          : Array.isArray(item?.for_counties) &&
                              typeof item?.for_counties[0] === "string"
                            ? item.for_counties.join(", ")
                            : item?.for_counties?.length > 0
                              ? item.for_counties.map((state) => state.name).join(", ")
                              : ""}
                      </td>

                      <td style={{ width: "35px" }}>
                        {item?.background_pdf ? (
                          <i
                            className="ic-generate-document-pdf ic ic-25"
                            style={{ position: "relative", top: "2px" }}
                            onClick={() => handleDocPreview(item?.background_pdf)}
                          />
                        ) : (
                          <>
                            <input
                              type="file"
                              id={`upload-file-${item?.id}`}
                              style={{ display: "none" }}
                              onChange={(e) => handleFileUpload(e, item?.id)}
                            />

                            <label
                              htmlFor={`upload-file-${item?.id}`}
                              style={{ cursor: "pointer", marginBottom: "0px" }}
                            >
                              <i
                                style={{ position: "relative", top: "2px" }}
                                className="ic-pdf-icon-grey ic ic-25"
                              />
                            </label>
                          </>
                        )}
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          color: "red",
                        }}
                      >
                        {item?.page_numbers > 0
                          ? item?.page_numbers !== item?.background_pdf?.page_count
                            ? item?.background_pdf?.page_count
                            : null
                          : null}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {
        <Modal show={state.show} onHide={() => dispatch({ type: "HIDE_MODAL" })}>
          <Modal.Header>
            <Modal.Title
              dangerouslySetInnerHTML={{ __html: state.status }}
              className="modal-title h4 justify-content-center text-center"
            />
          </Modal.Header>
          <Modal.Footer style={{ borderTop: "none" }}>
            <Button
              variant="secondary"
              className="mx-auto"
              onClick={() => dispatch({ type: "HIDE_MODAL" })}
            >
              Dismiss
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

export default CourtForms;
